import { d } from 'core/service/lib/decimal'

const thousandSeparator = (text) => (text ? String(text).replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '')

export const roundDown = (number, decimalPlaces = 0) => {
  const exponent = Math.pow(10, decimalPlaces)

  const roundDownNumber = d(number)
    .times(exponent)
    .floor()
    .dividedBy(exponent)

  return roundDownNumber.toNumber()
}

export const roundUp = (number, decimalPlaces = 0) => {
  const exponent = Math.pow(10, decimalPlaces)

  const roundUpNumber = d(number)
    .times(exponent)
    .ceil()
    .dividedBy(exponent)

  return roundUpNumber.toNumber()
}

export const round = (number, decimalPlaces = 0) => {
  const exponent = Math.pow(10, decimalPlaces)

  const roundDownNumber = d(
    Math.round(
      d(number)
        .times(exponent)
        .toNumber()
    )
  ).dividedBy(exponent)

  return roundDownNumber.toNumber()
}

export const formatNumber = (unformattedNumber, decimalPlaces = 0, isRound = false, defaultToZero = true) => {
  if (!unformattedNumber && defaultToZero) {
    return '0'
  }

  const numberWithDecimals = isRound
    ? round(unformattedNumber, decimalPlaces).toFixed(decimalPlaces)
    : roundDown(unformattedNumber, decimalPlaces).toFixed(decimalPlaces)

  const [whole, decimal] = numberWithDecimals.split('.')
  if (!decimalPlaces) {
    return `${thousandSeparator(whole)}`
  } else {
    return `${thousandSeparator(whole)}.${decimal}`
  }
}
